document.addEventListener('DOMContentLoaded', () => {
  initHeaderScroll();
  initMobileNav();
  initSmoothScroll();
  initScrollReveal();
  initFormHandler();
});

function initHeaderScroll() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  let ticking = false;

  function onScroll() {
    if (ticking) return;

    requestAnimationFrame(() => {
      if (header) header.classList.toggle('scrolled', window.scrollY > 40);
      ticking = false;
    });
    ticking = true;
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}

function initMobileNav() {
  const toggle = document.querySelector('.nav-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  if (!toggle || !mobileNav) return;

  const closeMobileNav = () => {
    toggle.classList.remove('active');
    mobileNav.classList.remove('open');
    mobileNav.setAttribute('aria-hidden', 'true');
    mobileNav.setAttribute('inert', '');
    document.body.style.overflow = '';
  };

  toggle.addEventListener('click', () => {
    const isOpen = mobileNav.classList.toggle('open');
    toggle.classList.toggle('active', isOpen);
    mobileNav.setAttribute('aria-hidden', String(!isOpen));
    mobileNav.toggleAttribute('inert', !isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';
  });

  mobileNav.querySelectorAll('.mobile-nav-link').forEach((link) => {
    link.addEventListener('click', closeMobileNav);
  });
}

function initSmoothScroll() {
  document.querySelectorAll('a[href*="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const href = link.getAttribute('href');
      if (!href || href === '#') return;

      const targetId = href.slice(href.indexOf('#') + 1);
      const target = targetId ? document.getElementById(targetId) : null;
      if (!target) return;

      event.preventDefault();
      const header = document.querySelector('.site-header');
      const headerHeight = header instanceof HTMLElement ? header.offsetHeight : 0;
      const top = target.getBoundingClientRect().top + window.scrollY - headerHeight - 20;
      window.scrollTo({ top, behavior: 'smooth' });
      window.history.pushState(null, '', `#${targetId}`);
    });
  });
}

function initScrollReveal() {
  const selectors = [
    '.pricing-hero-inner',
    '.section-tag',
    '.tier-card',
    '.philosophy-content',
    '.faq-title',
    '.faq-item',
    '.signal-content'
  ];

  selectors.forEach((selector) => {
    document.querySelectorAll(selector).forEach((element) => element.classList.add('reveal'));
  });

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.reveal').forEach((element) => element.classList.add('visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.05 }
  );

  document.querySelectorAll('.reveal').forEach((element) => observer.observe(element));
}

import { setSafeHtml } from './safe-html.js'

function initFormHandler() {
  const form = document.getElementById('signup-form');
  if (!(form instanceof HTMLFormElement)) return;

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    const input = form.querySelector('input[type="email"]');
    const button = form.querySelector('button');
    if (!(input instanceof HTMLInputElement) || !(button instanceof HTMLButtonElement)) return;
    if (!input.value) return;

    const originalHTML = button.innerHTML;
    setSafeHtml(button, '<span>Planting...</span>');
    button.disabled = true;
    button.style.opacity = '0.7';

    await new Promise((resolve) => setTimeout(resolve, 1400));

    setSafeHtml(button, `
      <span>Seed Planted!</span>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
        <polyline points="20 6 9 17 4 12"/>
      </svg>
    `);
    button.style.background = 'var(--indigo)';
    button.style.opacity = '1';

    setTimeout(() => {
      setSafeHtml(button, originalHTML);
      button.style.background = '';
      button.disabled = false;
      input.value = '';
    }, 2500);
  });
}
